
const KLIAN_CONFIG = {
    logo: 'https://cdn.re7.tech/partners/klian/favicon.svg',
    favicon: 'https://cdn.re7.tech/partners/klian/favicon.ico',
}

module.exports = { KLIAN_CONFIG }


